export default {
  // 计算时间差
  getDatePoor (start, end) {
    end = end || new Date()
    let startTime
    let endTime
    if (start instanceof Date) {
      startTime = new Date(start).getTime()
    } else {
      if (this.isIE()) {
        startTime = new Date(Date.parse(start.replace(/-/g, '/'))).getTime()
      } else {
        startTime = new Date(start).getTime()
      }
    }
    if (end instanceof Date) {
      endTime = new Date(end).getTime()
    } else {
      if (this.isIE()) {
        endTime = new Date(Date.parse(end.replace(/-/g, '/'))).getTime()
      } else {
        endTime = new Date(end).getTime()
      }
    }
    if (startTime > endTime) {
      let curTime = new Date().getTime()
      return curTime - startTime
    }
    return endTime - startTime
  },
  /**
   * 比较2个日期大小
   */
  compareDate (date1, date2) {
    let time1
    let time2
    if (typeof date1 === 'string' && typeof date2 === 'string') {
      try {
        if (date1.substring(0, 10) === date2.substring(0, 10)) {
          return true
        }
      } catch (e) {

      }
    }
    if (date1 instanceof Date) {
      time1 = date1.getTime()
    } else if (typeof date1 === 'string') {
      if (this.isIE()) {
        time1 = new Date(Date.parse(date1.replace(/-/g, '/'))).getTime()
      } else {
        time1 = new Date(date1).getTime()
      }
    }
    if (date2 instanceof Date) {
      time2 = date2.getTime()
    } else if (typeof date2 === 'string') {
      if (this.isIE()) {
        time2 = new Date(Date.parse(date2.replace(/-/g, '/'))).getTime()
      } else {
        time2 = new Date(date2).getTime()
      }
    }
    return time1 >= time2
  },
  /**
   * 秒转天时分秒
   */
  secondToDate (second) {
    if (!second) {
      return ''
    }
    second = parseInt(second)
    let s = 0
    let m = 0
    let h = 0
    let d = 0
    s = second % 60
    m = parseInt(second / 60)
    if (m >= 60) {
      h = parseInt(m / 60)
      m = m % 60
    }
    if (h >= 24) {
      d = parseInt(h / 24)
    }
    h = h % 24
    if (d !== 0) {
      return d + '天' + h + '时' + m + '分' + s + '秒'
    }
    if (h !== 0) {
      return h + '时' + m + '分' + s + '秒'
    }
    if (m !== 0) {
      return m + '分' + s + '秒'
    }
    return s + '秒'
  },
  /**
   * 日期格式化
   */
  dateFormat (date = new Date(), fmt = 'yyyy-MM-dd hh:mm:ss') {
    date = typeof date === 'number' ? new Date(date) : date
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      'S': date.getMilliseconds()
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
      }
    }
    return fmt
  },
  /**
   * 添加减少年  返回新的日期对象
   */
  addYear (date, year = 0) {
    if (Math.abs(year) === 0) {
      return date
    }
    return new Date(date.getFullYear() + year, date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds())
  },
  // 改变时间分割点
  dataXinyue (row) {
    if (row) {

      return row.replace(/-/g, '.');
    } else {
      return ''
    }
  },
  /**
   * 添加减少月  返回新的日期对象
   */
  addMonth (date, month = 0) {
    if (Math.abs(month) === 0) {
      return date
    }
    return new Date(date.getFullYear(), date.getMonth() + month, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds())
  },
  /**
   * 添加减少天数  返回新的日期对象
   */
  addDate (date, days = 0) {
    if (Math.abs(days) === 0) {
      return date
    }
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + days, date.getHours(), date.getMinutes(), date.getSeconds())
  },
  /**
   * 添加减少小时  返回新的日期对象
   */
  addHour (date, hour = 0) {
    if (Math.abs(hour) === 0) {
      return date
    }
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours() + hour, date.getMinutes(), date.getSeconds())
  },
  /**
   * 添加减少分钟  返回新的日期对象
   */
  addMinute (date, minute = 0) {
    if (Math.abs(minute) === 0) {
      return date
    }
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes() + minute, date.getSeconds())
  },
  /**
   * 添加减少秒钟  返回新的日期对象
   */
  addSecond (date, second = 0) {
    if (Math.abs(second) === 0) {
      return date
    }
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds() + second)
  },
  /**
   * 月 日 时 分 秒的值小于的10时 前面补充0
   */
  getFullStr (str) {
    str = str + ''
    if (str.length === 1) {
      return '0' + str
    }
    return str
  },
  /**
   * 获取当前日期是当月的第几周
   */
  getNowWeek (nowDate = new Date().getDate(), day = nowDate + 6 - new Date().getDay()) {
    return parseInt((nowDate + day) / 7)
  },
  isLeapYear (year = new Date().getFullYear()) {
    year = parseInt(year)
    if (!isNaN(year) || this.$util.stringUtil.isEmpty(year)) {
      return false
    }
    return (year % 4 === 0) && (year % 100 !== 0 || year % 400 === 0)
  },
  /**
   * 获取当月最大天数
   */
  getMonthMaxDate (date = new Date()) {
    let maxDate = [31, 0, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    if (!(date instanceof Date)) {
      return 0
    }
    if (date.getMonth() === 1) {
      if (this.isLeapYear(date.getFullYear())) {
        return 29
      } else {
        return 28
      }
    }
    return maxDate[date.getMonth()]
  },
  /**
   * 获取当月 日期集合 包含前后
   */
  getMonthWeekList (date = new Date()) {
    // 当前日期
    let nowDate = date.getDate()
    let beginDate
    if (this.isIE()) {
      if (date instanceof Date) {
        beginDate = new Date(date)
      } else {
        beginDate = new Date(Date.parse(date.replace(/-/g, '/')))
      }
    } else {
      beginDate = new Date(date)
    }
    beginDate.setDate(1)
    let maxDate = this.getMonthMaxDate(date)
    //		let beginDay = 6 - beginDate.getDay()
    //		let beginWeek =  this.getNowWeek(beginDate.getDate(), beginDate.getDate() + 6 - beginDate.getDay())
    let isSundayBegin = beginDate.getDay() === 0
    //		let maxWeek = Math.ceil((maxDate + 6 - beginDate.getDay()) / 7)
    let prevDate = new Date(beginDate)
    prevDate.setMonth(prevDate.getMonth() - 1)
    let prevMountMaxDate = this.getMonthMaxDate(prevDate)
    let weekList = []
    let day = 1
    for (let i = 0; i < 6; i++) {
      if (i === 0) {
        if (isSundayBegin) {
          let week = []
          for (let j = 6; j > 0; j--) {
            let date = new Date(beginDate)
            date.setMonth(date.getMonth() - 1)
            week.push({
              dateStr: date.getFullYear() + '-' + this.getFullStr(date.getMonth() + 1) + '-' + this.getFullStr(prevMountMaxDate - j) + ' 00:00:00',
              day: prevMountMaxDate - j,
              month: date.getMonth(),
              year: date.getFullYear()
            })
          }
          weekList.push(week)
        } else {
          let week = []
          for (let j = 0; j <= 6; j++) {
            let date = new Date(beginDate)
            date.setMonth(date.getMonth() - 1)
            if (j < beginDate.getDay()) {
              let day = prevMountMaxDate - beginDate.getDay() + j + 1
              week.push({
                dateStr: date.getFullYear() + '-' + this.getFullStr(date.getMonth() + 1) + '-' + this.getFullStr(day) + ' 00:00:00',
                day: day,
                month: date.getMonth(),
                year: date.getFullYear()
              })
            } else {
              week.push({
                dateStr: beginDate.getFullYear() + '-' + this.getFullStr(beginDate.getMonth() + 1) + '-' + this.getFullStr(day) + ' 00:00:00',
                day: day,
                month: beginDate.getMonth(),
                year: beginDate.getFullYear()
              })
              day++
            }
          }
          weekList.push(week)
        }
      } else {
        let week = []
        if (day + 7 > maxDate) {
          for (let j = 0; j <= 6; j++) {
            week.push({
              dateStr: beginDate.getFullYear() + '-' + this.getFullStr(beginDate.getMonth() + 1) + '-' + this.getFullStr(day) + ' 00:00:00',
              day: day,
              month: beginDate.getMonth(),
              year: beginDate.getFullYear()
            })
            day++
            if (day > maxDate) {
              day = 1
              beginDate.setMonth(beginDate.getMonth() + 1)
            }
          }
        } else {
          for (let j = 0; j <= 6; j++) {
            week.push({
              dateStr: beginDate.getFullYear() + '-' + this.getFullStr(beginDate.getMonth() + 1) + '-' + this.getFullStr(day) + ' 00:00:00',
              day: day,
              month: beginDate.getMonth(),
              year: beginDate.getFullYear()
            })
            day++
          }
        }
        weekList.push(week)
      }
    }
    return weekList
  },
  /**
   * 数字字符串转日期格式字符串
   */
  strToDateFormat (str, fmt = 'yyyy-MM-dd hh:mm:ss') {
    if (str !== null && str !== '') {
      let date = new Date()
      if (str.length === 8) {
        date.setFullYear(str.substring(0, 4))
        date.setMonth(str.substring(4, 6))
        date.setDate(str.substring(6, 8))
        return this.dateFormat(date, fmt)
      } else if (str.length === 14) {
        date.setFullYear(str.substring(0, 4))
        date.setMonth(str.substring(4, 6))
        date.setDate(str.substring(6, 8))
        date.setHours(str.substring(0, 4))
        date.setMinutes(str.substring(4, 6))
        date.setSeconds(str.substring(6, 8))
        return this.dateFormat(date, fmt)
      }
    }
    return str
  },
  /**
   * 获取传入年的所有月数组 并且判断哪些月是可点击的
   * @param minDate [type=String || Date] 最小日期 如 1900-01-01 00:00:00
   * @param maxDate [type=String || Date] 最大日期 如 2100-01-01 00:00:00
   * @param nowYear [type=String] 要获取月的年份
   */
  getMonthArr (minDate = '1900-01-01 00:00:00',
    maxDate = '2100-01-01 00:00:00',
    nowYear = new Date().getFullYear()) {
    let arr = []
    let nowDate = new Date()
    nowDate.setFullYear(nowYear)
    if (typeof minDate === 'string') {
      if (this.isIE()) {
        minDate = new Date(Date.parse(minDate.replace(/-/g, '/')))
      } else {
        minDate = new Date(minDate)
      }
    }
    if (typeof maxDate === 'string') {
      if (this.isIE()) {
        maxDate = new Date(Date.parse(maxDate.replace(/-/g, '/')))
      } else {
        maxDate = new Date(maxDate)
      }
    }
    if (minDate.getFullYear() < nowDate.getFullYear() && maxDate.getFullYear() > nowDate.getFullYear()) {
      for (let i = 1; i <= 12; i++) {
        arr.push({
          name: i + '月',
          isClick: true,
          month: i - 1
        })
      }
    } else if (minDate.getFullYear() < nowDate.getFullYear() && maxDate.getFullYear() === nowDate.getFullYear()) {
      for (let i = 1; i <= maxDate.getMonth() + 1; i++) {
        arr.push({
          name: i + '月',
          isClick: true,
          month: i - 1
        })
      }
      for (let i = maxDate.getMonth() + 2; i <= 12; i++) {
        arr.push({
          name: i + '月',
          isClick: false,
          month: i - 1
        })
      }
    } else if (minDate.getFullYear() === nowDate.getFullYear() && maxDate.getFullYear() > nowDate.getFullYear()) {
      for (let i = 1; i <= minDate.getMonth(); i++) {
        arr.push({
          name: i + '月',
          isClick: false,
          month: i - 1
        })
      }
      for (let i = minDate.getMonth() + 1; i <= 12; i++) {
        arr.push({
          name: i + '月',
          isClick: true,
          month: i - 1
        })
      }
    } else if (minDate.getFullYear() === nowDate.getFullYear() && maxDate.getFullYear() === nowDate.getFullYear()) {
      for (let i = 1; i <= minDate.getMonth(); i++) {
        arr.push({
          name: i + '月',
          isClick: false,
          month: i - 1
        })
      }
      for (let i = minDate.getMonth() + 1; i <= maxDate.getMonth() + 1; i++) {
        arr.push({
          name: i + '月',
          isClick: true,
          month: i - 1
        })
      }
      for (let i = maxDate.getMonth() + 2; i <= 12; i++) {
        arr.push({
          name: i + '月',
          isClick: false,
          month: i - 1
        })
      }
    }
    return arr
  },
  /** 
   * 获取传入年所在区间的年份列表 并判断哪些年是可以点击的
   * @author bruce.yang
   * @param minDate [type=String || Date] 最小日期 如 1900-01-01 00:00:00
   * @param maxDate [type=String || Date] 最大日期 如 2100-01-01 00:00:00
   * @param maxLen [type=Number] 当前列表的最大数量
   * @param beginYear [type=Number] 起始的年份
   * @param endYear [type=Number] 结束的年份
   */
  getYearArr (minDate = '1900-01-01 00:00:00',
    maxDate = '2100-01-01 00:00:00',
    maxLen = 20,
    beginYear = 0,
    endYear = 2101) {
    let arr = []
    let maxLenArr = []
    let minYear
    let maxYear
    if (typeof minDate === 'string') {
      if (this.isIE()) {
        minDate = new Date(Date.parse(minDate.replace(/-/g, '/')))
      } else {
        minDate = new Date(minDate)
      }
    }
    if (typeof maxDate === 'string') {
      if (this.isIE()) {
        maxDate = new Date(Date.parse(maxDate.replace(/-/g, '/')))
      } else {
        maxDate = new Date(maxDate)
      }
    }
    minYear = minDate.getFullYear()
    maxYear = maxDate.getFullYear()
    for (let i = beginYear; i < endYear; i++) {
      if (i !== beginYear && i % maxLen === 0) {
        arr.push(maxLenArr)
        maxLenArr = []
      }
      if (i < minYear || i > maxYear) {
        maxLenArr.push({
          name: i + '年',
          isClick: false,
          year: i
        })
      } else {
        maxLenArr.push({
          name: i + '年',
          isClick: true,
          year: i
        })
      }
    }
    return arr
  },
  /**
   * 判断是否是IE浏览器
   */
  isIE () {
    if ('ActiveXObject' in window || !!window.ActiveXObject) {
      return true
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/date.js